import { ComponentColor } from '@/enums'
import { Container } from './styles'
import { ButtonProps } from '../Button/Component'
import React from 'react'

export interface ButtonLinkProps extends ButtonProps {
  children: React.ReactNode
  color?: ComponentColor
  disabled?: boolean
  icon?: React.ElementType
  onClick?: () => void
  reverted?: boolean
}

export const ButtonLink = ({
  children,
  ...rest
}: Omit<ButtonLinkProps, 'children'> & { children?: React.ReactNode }) => (
  <Container {...rest}>{children}</Container>
)
